import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=1905e55e&scoped=true&"
import script from "./AppView.vue?vue&type=script&lang=ts&"
export * from "./AppView.vue?vue&type=script&lang=ts&"
import style0 from "./AppView.vue?vue&type=style&index=0&id=1905e55e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905e55e",
  null
  
)

export default component.exports